import React from 'react';
import PropTypes from 'prop-types';
import SpinnerModal from 'components/SpinnerModal';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import UiKitConfirmModal from 'components/UiKit/ConfirmModal';

const DeleteConfirmationSaleLocation = ({
  open,
  loading,
  onCancel,
  onSubmit
}) => {
  const deleteMessage = 'Are you sure you want to delete this location?';
  if (!open) return null;
  if (loading) return <SpinnerModal open message="Deleting Sale Location..." />;
  return (
    <UiKitConfirmModal
      title="Delete Location?"
      icon={<ErrorOutlineIcon style={{ color: '#CF3537' }} />}
      danger
      open={open}
      close={onCancel}
      confirmLabel="Delete"
      cancelLabel="Cancel"
      onConfirm={onSubmit}
    >
      <div className="pr-6">{deleteMessage}</div>
    </UiKitConfirmModal>
  );
};

DeleteConfirmationSaleLocation.propTypes = {
  loading: PropTypes.bool.isRequired,
  open: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired
};

export default DeleteConfirmationSaleLocation;
